export default __webpack_public_path__ + "static/NotoSans-Light-2cfb54d923b32fbd552590b3e0ee0cce.ttf";